import { DOM } from './state.js';

/**
 * Controla la apertura y cierre del sidebar.
 *
 * Notas técnicas:
 *   - El contenedor #sidebar tiene pointer-events-none para no bloquear la
 *     página cuando está cerrado. Al abrir necesitamos activar pointer-events
 *     EXPLÍCITAMENTE en el overlay (no alcanza con quitar pointer-events-none,
 *     porque el hijo hereda el `none` del padre #sidebar).
 *   - Bloqueamos el scroll del body mientras está abierto (patrón estándar de
 *     drawer/modal — evita que el usuario scrollee la página debajo).
 */
export function toggleSidebar(open) {
    if (!DOM.sidebarOverlay || !DOM.sidebarContent) return;
    if (open) {
        DOM.sidebarOverlay.classList.remove('pointer-events-none');
        DOM.sidebarOverlay.classList.add('pointer-events-auto');
        DOM.sidebarOverlay.style.opacity = '1';
        DOM.sidebarContent.style.transform = 'translateX(0)';
        document.body.style.overflow = 'hidden';
    } else {
        DOM.sidebarOverlay.classList.add('pointer-events-none');
        DOM.sidebarOverlay.classList.remove('pointer-events-auto');
        DOM.sidebarOverlay.style.opacity = '0';
        DOM.sidebarContent.style.transform = 'translateX(-100%)';
        document.body.style.overflow = '';
    }
    // Keep aria-expanded in sync with the actual sidebar state
    const hamburger = document.querySelector('[data-action="toggle-sidebar"]');
    if (hamburger) hamburger.setAttribute('aria-expanded', String(open));
}

/**
 * Activates the persistent connection warning banner (above the header).
 * For non-blocking errors where the app remains usable with fallback data
 * but the user should know the content may be stale.
 * @param {string} message - User-facing text. Rendered as plain text (safe).
 */
export function surfaceConnError(message) {
    if (!DOM.connBanner || !DOM.connMessage) return;
    DOM.connMessage.textContent = message;
    DOM.connBanner.classList.remove('hidden');
}

/**
 * Hides the connection warning banner when the app recovers normal state.
 */
export function clearConnError() {
    if (!DOM.connBanner) return;
    DOM.connBanner.classList.add('hidden');
    if (DOM.connMessage) DOM.connMessage.textContent = '';
}
